export default {
  aiSummary: 'Resumen IA',
  noisy: 'Noisy',
  loadingSummaries: 'Cargando resúmenes...',
  generating: 'Generando...',
  feedbackOptional: 'Comentarios (opcional)',
  feedbackPlaceholder: '¿Qué se podría mejorar?',
  done: 'Listo',
  generate: 'Generar',
  generalSummary: 'Resumen General',
  modelQuality: 'Calidad del Modelo',
  baseSales: 'Ventas Base',
  competition: 'Competencia',
  pricing: 'Precios',
  distribution: 'Distribución',
  economic: 'Económico',
  instantMarketingSales: 'Ventas de Marketing Instantáneo',
  seasonality: 'Estacionalidad',
  componentCorrelations: 'Correlaciones de Componentes',
  topMediaBySpend: 'Principales Medios por Inversión',
  topMediaByAttribution: 'Principales Medios por Atribución',
  attributionDisparities: 'Disparidades de Atribución',
  fastSaturatingMedia: 'Medios de Saturación Rápida',
  saturationAnalysis: 'Análisis de Saturación',
  highAndLowRoi: 'ROAS Alto y Bajo',
  mediaChannelStrategies: 'Estrategias de Canales de Medios',
  mediaChannelCorrelations: 'Correlaciones de Canales de Medios',
  errorGeneratingSection: 'Error al generar esta sección'
}
